<template>
  <!-- Need to add height inherit because Vue 2 don't support multiple root ele -->

  <div style="height: inherit">
    <div
      class="body-content-overlay"
      :class="{
        show:
          shallShowUserProfileSidebar ||
          shallShowActiveChatContactSidebar ||
          mqShallShowLeftSidebar,
      }"
      @click="
        mqShallShowLeftSidebar =
          shallShowActiveChatContactSidebar =
          shallShowUserProfileSidebar =
            false
      "
    />

    <b-modal
      id="modal-sms"
      cancel-variant="outline-secondary"
      hide-footer
      centered
      :title="$t('Send SMS')"
      no-close-on-backdrop
    >
      <b-row>
        <b-col md="12">
          <b-form-group
            :label="$t('Select SMS Number')"
            :invalid-feedback="$t('SMS Number is required.')"
            ref="sms_temp"
          >
            <v-select
              v-model="selectedSMS"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="smsOptions"
              :clearable="false"
              :disabled="smsLoading"
              label="title"
              :reduce="(val) => val.id"
              :placeholder="$t('Select number')"
            >
              <template #option="option">
                <div v-b-tooltip.hover.top :title="`${option.title}`">
                  <div class="font-weight-bolder line-height-1">
                    {{ option.title }}
                  </div>
                  <div class="font-small-2">{{ option.number }}</div>
                </div>
              </template>
              <template #selected-option="option">
                <div>
                  <div class="font-weight-bolder line-height-1">
                    {{ option.title }}
                  </div>
                  <div class="font-small-2">{{ option.number }}</div>
                </div>
              </template>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col md="12" class="text-right">
          <b-button variant="success" @click="sendSMS()" :disabled="smsSending">
            <b-spinner v-if="smsSending" small type="grow" />
            <span v-else>{{ $t("Send") }}</span>
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility"
      :sidebar-class="sidebarClass"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">
          {{
            subjectMode ? $t("Subject-wise Notifications") : $t("Notifications")
          }}
        </h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hideSideBar()"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="">
          <!-- Subject Mode Form -->
          <template v-if="subjectMode">
            <b-col md="12">
              <b-form-group
                :label="$t('Select Teacher')"
                :invalid-feedback="$t('Teacher is required.')"
              >
                <v-select
                  v-model="selectedTeacher"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="teachers"
                  :clearable="false"
                  label="name"
                  :reduce="(val) => val.id"
                  :placeholder="$t('Select teacher')"
                />
              </b-form-group>
            </b-col>
            <b-col md="10">
              <b-form-group
                :label="$t('Select Subject')"
                :invalid-feedback="$t('Subject is required.')"
              >
                <v-select
                  v-model="selectedSubject"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="debugSubjects"
                  :clearable="true"
                  :disabled="!selectedTeacher || subjectLoading"
                  :loading="subjectLoading"
                  label="name"
                  :reduce="(val) => val.id"
                  :placeholder="$t('Select subject')"
                >
                  <template slot="no-options">
                    <div v-if="subjectLoading" class="text-center">
                      <b-spinner
                        small
                        variant="primary"
                        class="mr-2"
                      ></b-spinner>
                      {{ $t("Loading subjects") }}...
                    </div>
                    <div v-else class="text-center text-muted">
                      {{ $t("No subjects available") }}
                    </div>
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col md="2" class="mt-2">
              <b-button
                variant="outline-primary"
                class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
                v-b-tooltip.hover.top
                :title="$t('Close Subject Mode')"
                @click="exitSubjectMode()"
              >
                <feather-icon icon="XIcon" />
              </b-button>
            </b-col>
            <!-- Recipients will be auto-populated based on selected teacher and subject -->
            <b-col
              md="12"
              v-if="
                selectedTeacher && selectedSubject && contactList.length > 0
              "
            >
              <b-alert variant="info" show>
                <feather-icon icon="UsersIcon" class="mr-1" />
                <strong>{{ contactList.length }}</strong>
                {{ $t("students will receive this notification") }}
              </b-alert>
            </b-col>
            <!-- Template option - hidden for specific domains in mobile view -->
            <b-col
              md="12"
              v-if="!shouldHideTemplateInMobile"
              :key="'template-' + shouldHideTemplateInMobile"
            >
              <b-form-group
                :label="$t('Select template')"
                :invalid-feedback="$t('Template is required')"
                ref="temp"
              >
                <v-select
                  v-model="msgID"
                  :disabled="otherLoading"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="items"
                  :reduce="(val) => val.id"
                  :clearable="false"
                  @input="LoadMedia()"
                  @search:blur="CheckTemp()"
                  ref="temp"
                  label="title"
                  :placeholder="$t('Select template')"
                />
              </b-form-group>
            </b-col>

            <!-- Attachment option for specific domains in mobile view -->
            <b-col md="12" v-if="shouldShowAttachmentInMobile">
              <b-form-group :label="$t('Attachment')" ref="attachment">
                <b-input-group>
                  <b-form-input
                    v-model="attachmentFileName"
                    :placeholder="$t('No file selected')"
                    readonly
                  />
                  <b-input-group-append>
                    <b-button
                      variant="outline-primary"
                      @click="$refs.attachmentFile.click()"
                      :disabled="attachmentUploading"
                    >
                      <b-spinner
                        v-if="attachmentUploading"
                        small
                        variant="primary"
                        :label="$t('Spinning')"
                      ></b-spinner>
                      <feather-icon v-else icon="PaperclipIcon" size="16" />
                      {{
                        attachmentUploading
                          ? $t("Uploading") + "..."
                          : $t("Choose File")
                      }}
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
                <input
                  type="file"
                  ref="attachmentFile"
                  hidden
                  @change="uploadAttachment()"
                  accept="image/*,.pdf,video/mp4,.doc,.docx,.txt"
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group :label="$t('Message')" ref="msg">
                <b-form-textarea
                  ref="msg"
                  :placeholder="$t('your message.')"
                  v-model="myObj.message"
                  rows="5"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
            <!-- Send WhatsApp Button -->
            <b-col md="12">
              <b-button
                variant="success"
                :disabled="requestWA || otherLoading"
                class="mt-2"
                @click="WhatsAppSubject()"
                block
              >
                <div v-if="requestWA">
                  <b-spinner
                    small
                    variant="light"
                    type="grow"
                    :label="$t('Spinning')"
                  ></b-spinner>
                </div>
                <span v-else>{{ $t("Send WhatsApp") }}</span>
              </b-button>
            </b-col>

            <!-- Send Notification Button -->
            <b-col md="12">
              <b-button
                variant="info"
                :disabled="notificationSending || otherLoading"
                class="mt-2"
                @click="sendSubjectNotification()"
                block
              >
                <div v-if="notificationSending">
                  <b-spinner
                    small
                    variant="light"
                    type="grow"
                    :label="$t('Spinning')"
                  ></b-spinner>
                </div>
                <span v-else>
                  <feather-icon icon="BellIcon" class="mr-1" />
                  {{ $t("Send Notification") }}
                </span>
              </b-button>
            </b-col>

            <!-- Clear Outbox -->
            <b-col md="12" v-if="pendingCount > 0">
              <b-button
                variant="danger"
                class="mt-2"
                @click="ClearOutBox()"
                block
              >
                <div v-if="requestPending">
                  <b-spinner
                    small
                    variant="light"
                    type="grow"
                    :label="$t('Spinning')"
                  ></b-spinner>
                </div>
                <span v-else>{{ $t("Clear Outbox") }}</span>
              </b-button>
            </b-col>
          </template>

          <!-- Regular Mode Form -->
          <template v-else>
            <b-col md="12" v-if="!byRecipients">
              <b-form-group
                :label="$t('Select Status')"
                :invalid-feedback="$t('Status is required.')"
              >
                <v-select
                  v-model="currentSt"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="statusOptions"
                  :clearable="false"
                  label="text"
                  :reduce="(val) => val.value"
                  :placeholder="$t('Select status')"
                />
              </b-form-group>
            </b-col>
            <b-col md="10" v-if="byRecipients">
              <b-form-group
                :label="$t('Select Recipients')"
                :invalid-feedback="$t('Recipients is required.')"
                ref="recip"
              >
                <v-select
                  ref="recip"
                  multiple
                  :filterBy="dropFilter"
                  :closeOnSelect="false"
                  v-model="selectedRec"
                  :disabled="recLoading"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="contactList"
                  :clearable="false"
                  :placeholder="$t('Select Recipients')"
                  label="name"
                >
                  <!-- @input="setRecep()" -->
                  <template slot="option" slot-scope="option">
                    <div class="d-flex align-items-center">
                      <b-avatar
                        v-if="option.avatar == null || option.avatar == ''"
                        size="30"
                        src="https://cdn.cloudious.net/file-1677912450367-333289208.png"
                        class="badge-minimal"
                        variant="transparent"
                      />
                      <b-avatar
                        v-else
                        size="30"
                        :src="option.avatar"
                        class="badge-minimal"
                        variant="transparent"
                      />
                      <div class="chat-info flex-grow-1 ml-1">
                        <h5 class="mb-0">
                          {{ option.name }}
                        </h5>
                        <p class="card-text text-truncate">
                          {{ option.details }}
                        </p>
                      </div>
                    </div>
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col :md="showSubjectIcon ? '8' : '10'" v-else>
              <b-form-group
                :label="$t('Select ' + classLabel)"
                :invalid-feedback="$t(classLabel + ' is required')"
                ref="class"
              >
                <v-select
                  ref="class"
                  multiple
                  :closeOnSelect="false"
                  v-model="classID"
                  :disabled="otherLoading"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="classesOptions"
                  :clearable="false"
                  label="name"
                  :reduce="(val) => val.id"
                  @input="FillSections()"
                  :placeholder="$t('Select ' + classLabel)"
                />
              </b-form-group>
            </b-col>
            <b-col md="2" class="mt-2" v-if="byRecipients">
              <b-button
                variant="outline-primary"
                class="btn-icon mr-1 mb-1 mb-sm-0"
                v-b-tooltip.hover.top
                :title="$t('Close Recipients')"
                @click="openMore()"
              >
                <feather-icon icon="XIcon" />
              </b-button>
            </b-col>
            <b-col md="2" class="mt-2" v-else>
              <b-button
                variant="outline-primary"
                class="btn-icon mr-1 mb-1 mb-sm-0"
                v-b-tooltip.hover.top
                :title="$t('Show Recipients')"
                @click="openMore()"
              >
                <feather-icon icon="UsersIcon" />
              </b-button>
            </b-col>
            <b-col
              md="1"
              class="mt-2"
              v-if="!byRecipients && !subjectMode && showSubjectIcon"
            >
              <b-button
                variant="outline-info"
                class="btn-icon mr-1 mb-1 mb-sm-0"
                v-b-tooltip.hover.top
                :title="$t('Subject-wise Students')"
                @click="openSubjectMode()"
              >
                <feather-icon icon="BookOpenIcon" />
              </b-button>
            </b-col>
            <b-col md="1" class="mt-2" v-if="subjectMode">
              <b-button
                variant="outline-danger"
                class="btn-icon mr-1 mb-1 mb-sm-0"
                v-b-tooltip.hover.top
                :title="$t('Close Subject Mode')"
                @click="exitSubjectMode()"
              >
                <feather-icon icon="XIcon" />
              </b-button>
            </b-col>
            <b-col
              md="12"
              v-if="
                classID[0] != 0 &&
                classID[0] != -2 &&
                classID[0] != -1 &&
                !byRecipients
              "
            >
              <b-form-group
                :label="$t('Select ' + sectionLabel)"
                :invalid-feedback="$t(sectionLabel + ' is required')"
                ref="section"
              >
                <v-select
                  multiple
                  :closeOnSelect="false"
                  v-model="secID"
                  :disabled="otherLoading"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="admittedSections"
                  :reduce="(val) => val.id"
                  :clearable="false"
                  @input="checkSections()"
                  ref="section"
                  label="section"
                  :placeholder="$t('Select ' + sectionLabel)"
                />
              </b-form-group>
            </b-col>
            <b-col
              md="12"
              v-if="
                ['myskoolhappinessfoundation'].includes(reportDomain) &&
                classID[0] != -2 &&
                classID[0] != -1 &&
                !byRecipients
              "
            >
              <b-form-group
                :label="$t('Age Category')"
                :invalid-feedback="$t('Age category is required.')"
              >
                <v-select
                  v-model="ageCategory"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="ageOptions"
                  :clearable="false"
                  label="text"
                  :reduce="(val) => val.value"
                  :placeholder="$t('Select age category')"
                />
              </b-form-group>
            </b-col>

            <!-- Template option - hidden for specific domains in mobile view -->
            <b-col
              md="12"
              v-if="!shouldHideTemplateInMobile"
              :key="'template-regular-' + shouldHideTemplateInMobile"
            >
              <b-form-group
                :label="$t('Select template')"
                :invalid-feedback="$t('Template is required')"
                ref="temp"
              >
                <v-select
                  v-model="msgID"
                  :disabled="otherLoading"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="items"
                  :reduce="(val) => val.id"
                  :clearable="false"
                  @input="LoadMedia()"
                  @search:blur="CheckTemp()"
                  ref="temp"
                  label="title"
                  :placeholder="$t('Select template')"
                />
              </b-form-group>
            </b-col>

            <!-- Attachment option for specific domains in mobile view -->
            <b-col md="12" v-if="shouldShowAttachmentInMobile">
              <b-form-group :label="$t('Attachment')" ref="attachment">
                <b-input-group>
                  <b-form-input
                    v-model="attachmentFileName"
                    :placeholder="$t('No file selected')"
                    readonly
                  />
                  <b-input-group-append>
                    <b-button
                      variant="outline-primary"
                      @click="$refs.attachmentFile.click()"
                      :disabled="attachmentUploading"
                    >
                      <b-spinner
                        v-if="attachmentUploading"
                        small
                        variant="primary"
                        :label="$t('Spinning')"
                      ></b-spinner>
                      <feather-icon v-else icon="PaperclipIcon" size="16" />
                      {{
                        attachmentUploading
                          ? $t("Uploading") + "..."
                          : $t("Choose File")
                      }}
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
                <input
                  type="file"
                  ref="attachmentFile"
                  hidden
                  @change="uploadAttachment()"
                  accept="image/*,.pdf,video/mp4,.doc,.docx,.txt"
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group :label="$t('Message')" ref="msg">
                <b-form-textarea
                  ref="msg"
                  :placeholder="$t('your message')"
                  v-model="myObj.message"
                  rows="5"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                ref="date"
                v-if="
                  reportDomain == 'myskoolstjacob' &&
                  classID[0] != -2 &&
                  classID[0] != -1 &&
                  myObj.message.includes('{dues}')
                "
              >
                <div class="d-flex justify-content-between">
                  <label class="bv-no-focus-ring col-form-label pt-0"
                    >{{ $t("Last visit before") }}
                  </label>
                  <b-badge
                    variant="primary"
                    class="mb-50 cursor-pointer"
                    @click="currentDate = ''"
                  >
                    {{ $t("Clear") }}
                  </b-badge>
                </div>
                <flat-pickr
                  ref="date"
                  :config="config"
                  v-model="currentDate"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                />
              </b-form-group>
            </b-col>

            <b-col md="12" v-if="hideFields && !byRecipients">
              <b-form-group :label="$t('Custom Contacts')" ref="custom">
                <b-form-textarea
                  ref="custom"
                  :placeholder="$t('Enter phone number separated by comma')"
                  v-model="customContacts"
                  min-rows="5"
                ></b-form-textarea>
              </b-form-group>
            </b-col>

            <!-- && classID[0] != -1 -->
            <b-col md="12" v-if="classID[0] != -2 && !byRecipients">
              <b-button
                variant="primary"
                :disabled="request || otherLoading || draftSending"
                class="mt-2"
                @click="save('')"
                block
              >
                <div v-if="request">
                  <b-spinner
                    small
                    variant="light"
                    type="grow"
                    label="Spinning"
                  ></b-spinner>
                </div>
                <span v-else>{{ $t("Send") }}</span>
              </b-button>

              <!-- Send Notification Button -->
              <b-button
                variant="info"
                :disabled="notificationSending || otherLoading"
                class="mt-2"
                @click="sendNotification()"
                block
              >
                <div v-if="notificationSending">
                  <b-spinner
                    small
                    variant="light"
                    type="grow"
                    label="Spinning"
                  ></b-spinner>
                </div>
                <span v-else>
                  <feather-icon icon="BellIcon" class="mr-1" />
                  {{ $t("Send Notification") }}
                </span>
              </b-button>

              <!-- send sms button -->
              <!-- <b-button
                variant="warning"
                :disabled="smsSending || otherLoading"
                class="mt-2"
                @click="openSMSModal()"
                block
              >
                <div v-if="smsSending">
                  <b-spinner
                    small
                    variant="light"
                    type="grow"
                    label="Spinning"
                  ></b-spinner>
                </div>
                <span v-else>
                  <feather-icon icon="MessageSquareIcon" class="mr-1" />
                  Send SMS
                </span>
              </b-button> -->

              <!-- v-if="currentSt == 'present'" -->
              <b-button
                v-if="false"
                variant="warning"
                :disabled="request || otherLoading || draftSending"
                class="mt-2"
                @click="save('draft')"
                block
              >
                <div v-if="draftSending">
                  <b-spinner
                    small
                    variant="light"
                    type="grow"
                    label="Spinning"
                  ></b-spinner>
                </div>
                <span v-else>{{ $t("Send as Draft") }}</span>
              </b-button>
            </b-col>

            <!-- WhatsApp -->
            <b-col md="12" v-else-if="byRecipients">
              <b-button
                variant="success"
                :disabled="requestWA || otherLoading"
                class="mt-2"
                @click="WhatsAppRecip()"
                block
              >
                <div v-if="requestWA">
                  <b-spinner
                    small
                    variant="light"
                    type="grow"
                    label="Spinning"
                  ></b-spinner>
                </div>
                <span v-else>{{ $t("Send WhatsApp") }}</span>
              </b-button>

              <!-- Send Notification Button for Recipients -->
              <b-button
                variant="info"
                :disabled="notificationRecipSending || otherLoading"
                class="mt-2"
                @click="sendNotificationRecip()"
                block
              >
                <div v-if="notificationRecipSending">
                  <b-spinner
                    small
                    variant="light"
                    type="grow"
                    label="Spinning"
                  ></b-spinner>
                </div>
                <span v-else>
                  <feather-icon icon="BellIcon" class="mr-1" />
                  {{ $t("Send Notification") }}
                </span>
              </b-button>
            </b-col>

            <b-col md="12" v-else>
              <b-button
                variant="success"
                :disabled="requestWA || otherLoading"
                class="mt-2"
                @click="WhatsApp()"
                block
              >
                <div v-if="requestWA">
                  <b-spinner
                    small
                    variant="light"
                    type="grow"
                    label="Spinning"
                  ></b-spinner>
                </div>
                <span v-else>{{ $t("Send WhatsApp") }}</span>
              </b-button>
            </b-col>

            <!-- Pending -->
            <!-- <b-col md="12" v-if="pendingCount > 0">
              <b-button
                variant="warning"
                :disabled="requestPending || dataLoading"
                class="mt-2"
                @click="SendWhatsApp()"
                block
              >
                <div v-if="requestPending">
                  <b-spinner
                    small
                    variant="light"
                    type="grow"
                    label="Spinning"
                  ></b-spinner>
                </div>
                <span v-else>Outbox - {{ this.pendingCount }}</span>
              </b-button>
            </b-col> -->

            <!-- Clear Outbox -->
            <b-col md="12" v-if="pendingCount > 0">
              <b-button
                variant="danger"
                class="mt-2"
                @click="ClearOutBox()"
                block
              >
                <div v-if="requestPending">
                  <b-spinner
                    small
                    variant="light"
                    type="grow"
                    label="Spinning"
                  ></b-spinner>
                </div>
                <span v-else>{{ $t("Clear Outbox") }}</span>
              </b-button>
            </b-col>
          </template>
        </b-row>
      </b-form>
    </b-sidebar>

    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility4"
      :sidebar-class="sidebarClass"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">{{ $t("Select Recipients") }}</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility4 = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="">
          <b-col>
            <b-input-group>
              <b-input-group-prepend is-text style="cursor: pointer">
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>

              <b-form-input
                v-model="searchContacts"
                :placeholder="$t('Search') + '...'"
              >
              </b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
      </b-form>
      <b-table
        thead-class="hidden_header"
        class=""
        :tbody-tr-class="rowClass"
        show-empty
        ref="selectableTable"
        :items="filteredContacts"
        :fields="fields2"
        responsive
        hover
        selectable
        select-mode="multi"
        @row-selected="contactRow"
      >
        <template #cell(details)="data">
          <div class="d-flex">
            <b-avatar
              v-if="data.item.avatar == null || data.item.avatar == ''"
              size="42"
              src="https://cdn.cloudious.net/file-1677912450367-333289208.png"
              class="badge-minimal"
              variant="transparent"
            />
            <b-avatar
              v-else
              size="42"
              :src="data.item.avatar"
              class="badge-minimal"
              variant="transparent"
            />
            <div class="chat-info flex-grow-1 ml-2">
              <h5 class="mb-0">
                {{ data.item.name }}
              </h5>
              <p class="card-text text-truncate">
                {{ data.item.details }}
              </p>
            </div>
          </div>
        </template>
      </b-table>
    </b-sidebar>

    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility2"
      :sidebar-class="sidebarClass"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">{{ $t("Groups") }}</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility2 = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="mt-1">
          <b-col md="12">
            <b-form-group
              :label="$t('Name')"
              :invalid-feedback="$t('Name is required')"
              ref="grpName"
            >
              <b-form-input
                id="mc-first-name"
                :placeholder="$t('Enter group name')"
                ref="grpName"
                v-model="groupObj.name"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group :label="$t('Custom Contacts')" ref="custom">
              <b-form-textarea
                ref="custom"
                :placeholder="$t('Enter phone number separated by comma')"
                v-model="groupObj.customContacts"
                min-rows="5"
              ></b-form-textarea>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-button
              variant="primary"
              :disabled="request"
              class="mt-2"
              @click="createGroup()"
              block
            >
              <div v-if="request">
                <b-spinner
                  small
                  variant="light"
                  type="grow"
                  :label="$t('Spinning')"
                ></b-spinner>
              </div>
              <span v-else>{{ $t("Create") }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility3"
      :sidebar-class="sidebarClass"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">{{ $t("Templates") }}</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility3 = false"
        />
      </div>
      <!-- <b-form class="p-2" @submit.prevent>
        <b-row class="mt-1">
          <b-col md="12" class="p-0">
            <div
              v-for="(temp, index) in items"
              :key="temp.id"
              class="d-flex pt-0 pl-1 pr-1 pb-1"
            >
              <div class="mr-1">{{ index + 1 }})</div>
              <div v-if="temp.media" class="mr-1">
                <a
                  :href="temp.media"
                  target="_blank"
                  v-if="isImage(temp.media)"
                >
                  <b-img
                    :src="temp.media"
                    style="border-radius: 10px"
                    height="100px"
                    width="100px"
                  />
                </a>

                <a :href="temp.media" target="_blank" v-else>
                  <div class="file-type">
                    {{ temp.media.split(".").pop().toUpperCase() }}
                  </div>
                </a>
              </div>
              <div>
                <h5>{{ temp.message }}</h5>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-form> -->
      <b-form class="p-2" @submit.prevent>
        <b-row class="mt-1">
          <b-col>
            <b-input-group>
              <b-input-group-prepend is-text style="cursor: pointer">
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>

              <b-form-input
                v-model="searchQuery"
                :placeholder="$t('Search') + '...'"
              >
              </b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
      </b-form>

      <b-table
        class="mt-1"
        :tbody-tr-class="rowClass"
        show-empty
        ref="selectableTable"
        :items="filters"
        :fields="fields"
        responsive
        hover
        small
        selectable
        select-mode="single"
        @row-selected="onRowSelected"
      >
        <template #cell(media)="data">
          <div v-if="data.item.media !== null && data.item.media !== ''">
            <a
              :href="data.item.media"
              target="_blank"
              v-if="isImage(data.item.media)"
            >
              <b-img
                :src="data.item.media"
                style="border-radius: 10px"
                height="100px"
                width="100px"
              />
            </a>
            <video
              v-else-if="isVideo(data.item.media)"
              controls
              controlslist="nodownload"
              style="height: 100px; width: 100px"
              @click.stop
            >
              <source :src="data.item.media" type="video/mp4" />
            </video>

            <a :href="data.item.media" target="_blank" v-else>
              <div class="file-type">
                {{ data.item.media.split(".").pop().toUpperCase() }}
              </div>
            </a>
          </div>
          <div v-else>
            <span>{{ $t("No Media") }}</span>
          </div>
        </template>
      </b-table>
    </b-sidebar>

    <!-- Main Area -->

    <!-- <b-button
      v-if="openedOnce"
      variant="info"
      style="position: fixed; bottom: 1rem; right: 3rem"
      @click="showSidebar()"
    >
      Start
    </b-button> -->
    <!-- <b-row
      style="display: flex; align-items: center; justify-content: center; height: 100%;"
      v-if="dataLoading"
     
    >
      <b-spinner
        style="width: 4rem; height: 4rem"
        type="grow"
        variant="primary"
        label="Spinning"
      ></b-spinner>
    </b-row> -->

    <section class="chat-app-window">
      <!-- // v-if="!dataLoading" -->
      <!-- Start Chat Logo -->
      <div v-if="!opened" class="start-chat-area">
        <div class="mb-1 start-chat-icon">
          <feather-icon icon="EditIcon" size="56" />
        </div>
        <h4 class="sidebar-toggle start-chat-text" @click="showSidebar()">
          {{ $t("Send New Message") }}
        </h4>
      </div>

      <!-- Chat Content -->
      <div v-else class="active-chat">
        <!-- Chat Navbar -->

        <div class="chat-navbar">
          <header class="chat-header">
            <!-- Avatar & Name -->
            <div class="d-flex align-items-center">
              <!-- Toggle Icon -->
              <div class="sidebar-toggle d-block d-lg-none mr-1">
                <feather-icon
                  icon="MenuIcon"
                  class="cursor-pointer"
                  size="21"
                  @click="mqShallShowLeftSidebar = true"
                />
              </div>

              <b-avatar
                size="36"
                :src="openedContact.avatar"
                class="mr-1 cursor-pointer badge-minimal"
              />
              <!-- badge
                :badge-variant="
                  resolveAvatarBadgeVariant(activeChat.contact.status)
                " -->
              <!-- @click.native="shallShowActiveChatContactSidebar = true" -->
              <div>
                <h6 class="mb-0">
                  {{ openedContact.name }}
                </h6>
                <h6 class="mb-0" style="color: rgb(170 170 176)">
                  {{ openedContact.details }}
                </h6>
              </div>
            </div>

            <!-- Contact Actions -->
            <!-- <div class="d-flex align-items-center">
              <feather-icon
                icon="PhoneCallIcon"
                size="17"
                class="cursor-pointer d-sm-block d-none mr-1"
              />
              <feather-icon
                icon="VideoIcon"
                size="17"
                class="cursor-pointer d-sm-block d-none mr-1"
              />
              <feather-icon
                icon="SearchIcon"
                size="17"
                class="cursor-pointer d-sm-block d-none mr-50"
              />
              <div class="dropdown">
                <b-dropdown variant="link" no-caret toggle-class="p-0" right>
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="17"
                      class="align-middle text-body"
                    />
                  </template>
                  <b-dropdown-item> View Contact </b-dropdown-item>
                  <b-dropdown-item> Mute Notifications </b-dropdown-item>
                  <b-dropdown-item> Block Contact </b-dropdown-item>
                  <b-dropdown-item> Clear Chat </b-dropdown-item>
                  <b-dropdown-item> Report </b-dropdown-item>
                </b-dropdown>
              </div>
            </div> -->
          </header>
        </div>

        <!-- User Chat Area -->
        <div
          ref="refChatLogPS"
          id="chatcontent"
          :settings="perfectScrollbarSettings"
          class="user-chats scroll-area myscroll"
        >
          <div
            v-if="chatloading"
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              height: 100%;
            "
          >
            <b-spinner
              style="width: 4rem; height: 4rem"
              variant="primary"
              :label="$t('Spinning')"
            ></b-spinner>
          </div>
          <chat-log
            v-else
            :chat-data="openedContact"
            :user-chat="userChat"
            :profile-user-avatar="profileUserDataMinimal.avatar"
          />
        </div>

        <!-- Message Input -->
        <b-alert
          v-if="openedContact.number == '' || openedContact.number == null"
          show
          variant="danger"
          class="chat-app-form justify-content-center"
        >
          {{ $t("User's contact number is not updated") }}
        </b-alert>
        <b-form class="chat-app-form" @submit.prevent="send()" v-else>
          <b-input-group
            class="input-group-merge form-send-message mr-1"
            ref="message"
          >
            <b-form-input
              class="p-2"
              :disabled="
                openedContact.number == '' ||
                openedContact.number == null ||
                sendingMsg
              "
              v-model="inputMessage"
              :placeholder="$t('Enter your message')"
            />
            <b-input-group-append is-text>
              <feather-icon
                icon="MailIcon"
                size="18"
                v-b-tooltip.hover.top
                :title="$t('Templates')"
                class="cursor-pointer mr-50"
                @click="visibility3 = true"
              />
              <input
                type="file"
                id="fileProfile"
                hidden
                ref="fileProfile"
                @change="fileUpload()"
                accept="image/*,.pdf,video/mp4"
              />
              <b-spinner
                v-if="loading"
                variant="primary"
                small
                :label="$t('Spinning')"
              ></b-spinner>
              <feather-icon
                v-else
                icon="PaperclipIcon"
                v-b-tooltip.hover.top
                :title="$t('Upload')"
                size="18"
                @click="$refs.fileProfile.click()"
                style="cursor: pointer"
              />
            </b-input-group-append>
          </b-input-group>
          <b-button
            variant="primary"
            style="width: 120px"
            @click="send()"
            :disabled="
              openedContact.number == '' ||
              openedContact.number == null ||
              sendingMsg
            "
          >
            <b-spinner v-if="sendingMsg" small />
            {{ $t("Send") }}
          </b-button>
        </b-form>
      </div>
    </section>

    <!-- Active Chat Contact Details Sidebar -->
    <!-- <chat-active-chat-content-details-sidedbar
      :shall-show-active-chat-contact-sidebar.sync="
        shallShowActiveChatContactSidebar
      "
      :contact="activeChat.contact || {}"
    /> -->

    <!-- Sidebar -->
    <portal to="content-renderer-sidebar-left">
      <!-- :active-chat-contact-id="
          activeChat.contact ? activeChat.contact.id : null
        " -->
      <chat-left-sidebar
        :chats-contacts="chatData.chat"
        :contacts="chatData.contacts"
        :shall-show-user-profile-sidebar.sync="shallShowUserProfileSidebar"
        :profile-user-data="profileUserData"
        :profile-user-minimal-data="profileUserDataMinimal"
        :mq-shall-show-left-sidebar.sync="mqShallShowLeftSidebar"
        :settings="settings"
        :genSettings="fObj"
        :brandedSetting="brandedObj"
        @show-user-profile="showUserProfileSidebar"
        @open-chat="getChat"
        @open-new="showSidebar"
        @open-group="visibility2 = true"
        @load-settings="LoadSettings"
        @load-gen-settings="LoadGenSettings"
        @scroll-handle="scrollHandle"
        :moreChatLoading="moreChatLoading"
        :moreContactLoading="moreContactLoading"
        :dataLoading="dataLoading"
        :openedContact="openedContact"
      />
      <!-- v-if="!dataLoading" -->
    </portal>
  </div>
</template>

<script>
import store from "@/store";
import { ref, onUnmounted, nextTick } from "@vue/composition-api";
import {
  BBadge,
  BAvatar,
  BDropdown,
  BDropdownItem,
  BForm,
  BInputGroup,
  BFormInput,
  BButton,
  BFormTextarea,
  BSidebar,
  BRow,
  BCol,
  BFormGroup,
  BFormCheckbox,
  BModal,
  BSpinner,
  BAlert,
  BInputGroupPrepend,
  BInputGroupAppend,
  BImg,
  BTable,
  VBTooltip,
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
// import { formatDate } from '@core/utils/filter'
import { $themeBreakpoints } from "@themeConfig";
import { useResponsiveAppLeftSidebarVisibility } from "@core/comp-functions/ui/app";
import ChatLeftSidebar from "./ChatLeftSidebar.vue";
import chatStoreModule from "./chatStoreModule";
import ChatActiveChatContentDetailsSidedbar from "./ChatActiveChatContentDetailsSidedbar.vue";
import ChatLog from "./ChatLog.vue";
import useChat from "./useChat";
import { mapActions, mapGetters } from "vuex";
import { getUploadPath, uploadToMySkool } from "@/utils/gdriveUpload";
import { formatChatBulkSendMessage, isChatSendOk } from "@/utils/chatBulkSend";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    // BSV
    flatPickr,
    BBadge,
    BTable,
    BSpinner,
    BFormTextarea,
    BFormCheckbox,
    BSidebar,
    BRow,
    BImg,
    BCol,
    BAlert,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormGroup,
    BAvatar,
    BDropdown,
    BDropdownItem,
    BForm,
    BInputGroup,
    BFormInput,
    BButton,
    vSelect,
    BModal,

    // 3rd Party
    VuePerfectScrollbar,

    // SFC
    ChatLeftSidebar,
    ChatActiveChatContentDetailsSidedbar,
    ChatLog,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      currentDate: "",
      reportDomain: this.$store.state.report.replace(/_/g, ""),
      config: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      msgData: null,
      msgID: 0,
      qrCode: "",
      clientID: "",
      requestWA: false,
      customContacts: "",
      pendingCount: 0,
      requestPending: false,
      myObj: {
        media: "",
        message: "",
        clsIDs: [],
        secIDs: [],
        campusID: this.$store.state.userData.cId,
        userID: this.$store.state.userData.userID,
      },
      groupObj: {
        name: "",
        customContacts: "",
        campusID: this.$store.state.userData.cId,
      },
      visibility4: false,
      visibility3: false,
      visibility2: false,
      visibility: false,
      request: false,
      dataLoading: false,
      otherLoading: false,
      // openedOnce: false,
      statusOptions: [
        { text: "Present", value: "present" },
        { text: "Registered", value: "registered" },
      ],
      currentSt: "present",
      classID: [0],
      secID: [0],
      classes: [],
      classesOptions: [],
      admittedSections: [],
      ageOptions: [],
      ageCategory: null,
      empowerLevelOptions: [],
      empowerLevel: null,
      items: [],
      template: "",
      chatData: {
        chat: [],
        contacts: [],
      },
      userChat: [],
      opened: false,
      openedContact: null,
      sendingMsg: false,
      inputMessage: "",
      media: "",
      loading: false,
      settings: {},
      chatloading: false,
      chatInterval: null,
      silentChatLoading: false,
      hideFields: false,
      fields: [
        { label: "media", key: "media" },
        { label: "message", key: "message" },
      ],
      fields2: [{ label: "details", key: "details" }],
      searchQuery: "",
      customObj: {
        contactIDs: [],
        numbers: [],
      },
      selectedRec: [],
      byRecipients: false,
      searchContacts: "",
      contactList: [],
      rights: {},
      fObj: null,
      brandedObj: null,
      moreChatLoading: false,
      chatTotal: 0,
      chatPages: 1,
      currentChatPage: 1,
      moreContactLoading: false,
      contactTotal: 0,
      contactPages: 1,
      currentContactPage: 1,
      perPage: 200,
      recLoading: false,
      draftSending: false,
      notificationSending: false,
      notificationRecipSending: false,
      /** Cooldown after a send so accidental re-clicks get a reminder (frontend only). */
      notificationCooldownMs: 10 * 60 * 1000,
      subjectMode: false,
      selectedTeacher: null,
      selectedSubject: null,
      teachers: [],
      subjects: [],
      subjectLoading: false,
      studentsLoading: false,
      // Attachment related properties
      attachmentFileName: "",
      attachmentUploading: false,
      attachmentUrl: "",
      // Window width for reactive mobile detection
      windowWidth: window.innerWidth,
      // SMS sending related properties
      smsLoading: false,
      smsOptions: [],
      selectedSMS: null,
      smsSending: false,
    };
  },
  computed: {
    isHappiness() {
      return this.reportDomain == "myskoolhappinessfoundation";
    },
    filters: function () {
      return this.items.filter((pro) => {
        return (
          pro.title.toLowerCase().match(this.searchQuery.toLowerCase()) ||
          pro.message.toLowerCase().match(this.searchQuery.toLowerCase())
        );
      });
    },
    // using chatData.chat for now later on by api
    filteredContacts: function () {
      return this.contactList.filter((pro) => {
        return pro.name.toLowerCase().match(this.searchContacts.toLowerCase());
      });
    },
    // Debug subjects
    debugSubjects: function () {
      console.log("Current subjects array:", this.subjects);
      return this.subjects;
    },
    // Show subject icon based on domain
    showSubjectIcon: function () {
      return this.reportDomain === "myskoolskh";
    },
    // Check if we should hide template in mobile view for specific domains
    shouldHideTemplateInMobile: function () {
      const isMobile = this.windowWidth < 786; // Mobile breakpoint - less than 786px
      const isTargetDomain =
        this.reportDomain === "myskool" || this.reportDomain === "myskooliota";
      const shouldHide = isMobile && isTargetDomain;

      console.log("Template Hide Check:", {
        windowWidth: this.windowWidth,
        isMobile: isMobile,
        reportDomain: this.reportDomain,
        isTargetDomain: isTargetDomain,
        shouldHide: shouldHide,
        actualResult: shouldHide,
      });

      return shouldHide;
    },
    // Check if we should show attachment in mobile view for specific domains
    shouldShowAttachmentInMobile: function () {
      const isMobile = this.windowWidth < 786; // Mobile breakpoint - less than 786px
      const isTargetDomain =
        this.reportDomain === "myskool" || this.reportDomain === "myskooliota";
      console.log("Attachment Show Check:", {
        windowWidth: this.windowWidth,
        isMobile: isMobile,
        reportDomain: this.reportDomain,
        isTargetDomain: isTargetDomain,
        shouldShow: isMobile && isTargetDomain,
      });
      return isMobile && isTargetDomain;
    },
    // Get sidebar class based on screen size and domain
    sidebarClass: function () {
      const isMobile = this.windowWidth < 786;
      const isTargetDomain =
        this.reportDomain === "myskool" || this.reportDomain === "myskooliota";

      if (isMobile && isTargetDomain) {
        return "sidebar-mobile-wide"; // Custom class for wider mobile sidebar
      }
      return "sidebar-lg"; // Default class
    },
    allClassLabel: function () {
      return this.reportDomain == "myskoolhappinessfoundation"
        ? "Groups"
        : "Classes";
    },
    allSectionLabel: function () {
      return this.reportDomain == "myskoolhappinessfoundation"
        ? "Levels"
        : "Sections";
    },
    classLabel: function () {
      return this.reportDomain == "myskoolhappinessfoundation"
        ? "Group"
        : "Class";
    },
    sectionLabel: function () {
      return this.reportDomain == "myskoolhappinessfoundation"
        ? "Level"
        : "Section";
    },
  },
  watch: {
    selectedTeacher: {
      handler(newTeacherId) {
        if (newTeacherId && this.subjectMode) {
          this.loadTeacherSubjects(newTeacherId);
        }
      },
      immediate: false,
    },
    selectedSubject: {
      handler(newSubjectId) {
        if (newSubjectId && this.selectedTeacher && this.subjectMode) {
          this.loadStudentsByTeacherAndSubject(
            this.selectedTeacher,
            newSubjectId
          );
        }
      },
      immediate: false,
    },
  },
  async created() {
    if (!this.$store.state.rights[this.$route.name]) {
      this.$router.replace({
        name: "misc-not-authorized",
      });
    } else {
      this.rights = this.$store.state.rights[this.$route.name];

      this.classesOptions = [{ name: "All " + this.allClassLabel, id: 0 }];
      this.admittedSections = [
        { section: "All " + this.allSectionLabel, id: 0 },
      ];

      // this.LoadData();
      this.LoadRec();
      this.LoadOthers();
      this.LoadSettings();
      this.LoadGenSettings();
      this.LoadChatList("load");
      if (this.isHappiness) this.loadHappinessDropdowns();
      // this.LoadContact();

      //Pending whatsapp
      // var obj = {
      //   url:
      //     this.$store.state.domain +
      //     "Chat/WhatsAppPendingCount?db=" +
      //     this.$store.state.userData.db +
      //     "&cID=" +
      //     this.$store.state.userData.cId,
      //   token: this.$store.state.userData.token,
      // };
      // var data = await this.get(obj);
      // this.clientID = data.db;
      // this.pendingCount = data.data;
    }

    // Add window resize listener for mobile detection
    this.handleResize = () => {
      this.windowWidth = window.innerWidth;
      console.log("Window resized to:", this.windowWidth);
      // Force re-render to update computed properties
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    };
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    if (this.chatInterval) {
      clearInterval(this.chatInterval);
      this.chatInterval = null;
    }
    // Clean up the resize listener
    if (this.handleResize) {
      window.removeEventListener("resize", this.handleResize);
    }
  },
  methods: {
    ...mapActions({
      get: "get",
      post: "post",
      postObj: "postObj",
      put: "put",
      delete: "delete",
    }),

    showChatSendFeedback(res, fallbackMsg) {
      const processing = !!(res && res.backgroundProcessing);
      if (!isChatSendOk(res)) return false;

      const text = formatChatBulkSendMessage(res, fallbackMsg, (s) =>
        this.$t(s)
      );
      this.$bvToast.toast(text, {
        title: processing ? this.$t("Processing") : this.$t("Success"),
        variant: processing ? "info" : "success",
        solid: true,
        autoHideDelay: 6000,
      });
      // this.refreshWhatsAppPendingCount();
      this.refreshChat();
      return true;
    },

    handleSelectedChatSendResult(
      res,
      fallbackMsg,
      { closeSidebar = false } = {}
    ) {
      if (this.showChatSendFeedback(res, fallbackMsg)) {
        if (closeSidebar) this.visibility = false;
        return true;
      }
      if (res === false || res == null) {
        this.$bvToast.toast(this.$t("Request failed. Please try again."), {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
          autoHideDelay: 5000,
        });
      }
      return false;
    },

    async refreshWhatsAppPendingCount() {
      try {
        const data = await this.get({
          url:
            this.$store.state.domain +
            "Chat/WhatsAppPendingCount?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          token: this.$store.state.userData.token,
        });
        if (data && data.data != null) {
          this.pendingCount = data.data;
        }
      } catch (e) {
        // ignore
      }
    },

    // Add missing rowClass method
    rowClass(item, type) {
      if (!item || type !== "row") return "";
      return "";
    },
    getQR() {
      return this.qrCode;
    },
    showSidebar() {
      // Reset to normal view when opening sidebar
      this.subjectMode = false;
      this.byRecipients = false;
      this.selectedTeacher = null;
      this.selectedSubject = null;
      this.selectedRec = [];
      this.visibility = true;

      // Debug: Log current state
      console.log("Sidebar opened - Debug Info:", {
        windowWidth: window.innerWidth,
        reportDomain: this.reportDomain,
        shouldHideTemplate: this.shouldHideTemplateInMobile,
        shouldShowAttachment: this.shouldShowAttachmentInMobile,
      });
    },
    hideSideBar() {
      this.visibility = false;
    },
    contactRow(row) {
      // console.log(row);
      this.customObj.contactIDs = row.reduce((ids, c) => {
        ids.push(c.localID);
        return ids;
      }, []);
      // console.log(this.customObj);
    },
    isImage(url) {
      return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url);
    },
    isVideo(url) {
      return /\.(mp4)$/.test(url);
    },
    onRowSelected(row) {
      // console.log(row);
      this.inputMessage = row[0].message;
      this.media = row[0].media;
      this.visibility3 = false;
    },
    async getChat(contact, silentLoad = false) {
      // console.log(contact)
      if (!silentLoad) {
        this.inputMessage = "";
        this.media = null;
        this.chatloading = true;

        if (this.chatInterval) {
          clearInterval(this.chatInterval);
          this.chatInterval = null;
        }
      } else {
        if (this.silentChatLoading) return;
        this.silentChatLoading = true;
      }

      this.opened = true;
      this.openedContact = contact;

      try {
        if (contact && contact.number) {
          var config = {
            url:
              this.$store.state.domain +
              "Chat/LoadChatAdmin?db=" +
              this.$store.state.userData.db +
              "&number=" +
              contact.number,
            token: this.$store.state.userData.token,
          };
          const res = await this.get(config);

          if (
            this.openedContact &&
            this.openedContact.number === contact.number
          ) {
            const hadNewMessages =
              Array.isArray(res) &&
              (!Array.isArray(this.userChat) ||
                res.length > this.userChat.length);
            this.userChat = Array.isArray(res) ? res : [];

            if (!silentLoad || hadNewMessages) {
              setTimeout(() => {
                this.setChat();
              }, 200);
            }
          }
        } else {
          this.userChat = [];
        }
      } catch (e) {
        console.error(e);
      } finally {
        if (!silentLoad) {
          this.chatloading = false;

          if (contact && contact.number) {
            this.chatInterval = setInterval(() => {
              if (
                this.opened &&
                this.openedContact &&
                this.openedContact.number &&
                !this.chatloading &&
                !this.silentChatLoading
              ) {
                this.getChat(this.openedContact, true);
              }
            }, 7000);
          }
        } else {
          this.silentChatLoading = false;
        }
      }
    },
    setChat() {
      var elem = this.$refs["refChatLogPS"];
      // console.log(elem);
      if (elem) {
        elem.scrollTop = elem.scrollHeight;
      }
    },
    async fileUpload() {
      const file = this.$refs.fileProfile.files[0];
      if (!file) return;
      this.loading = true;
      try {
        const uploaded = await uploadToMySkool([file]);
        this.media = getUploadPath(uploaded[0]);
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async uploadAttachment() {
      const file = this.$refs.attachmentFile.files[0];
      if (!file) return;

      this.attachmentUploading = true;
      this.attachmentFileName = file.name;

      try {
        const uploaded = await uploadToMySkool([file]);
        this.attachmentUrl = getUploadPath(uploaded[0]);

        if (this.myObj.message.trim() === "") {
          this.myObj.message = `Attachment: ${this.attachmentUrl}`;
        } else {
          this.myObj.message += `\n\nAttachment: ${this.attachmentUrl}`;
        }

        this.$bvToast.toast("File uploaded successfully!", {
          title: this.$t("Success"),
          variant: "success",
          solid: true,
          autoHideDelay: 3000,
        });
      } catch (error) {
        console.error("Upload error:", error);
        this.$bvToast.toast("Failed to upload file. Please try again.", {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
          autoHideDelay: 5000,
        });
        this.attachmentFileName = "";
      } finally {
        this.attachmentUploading = false;
      }
    },
    async ClearOutBox() {
      //console.log("clearing...");
      try {
        await this.post({
          url:
            this.$store.state.domain +
            "Chat/ClearOutBox?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: "",
          message: "Outbox cleared.",
          context: this,
          token: this.$store.state.userData.token,
        });

        this.pendingCount = 0;
      } catch (ex) {
      } finally {
      }
    },
    createGroup() {
      if (
        this.groupObj.customContacts.trim() == "" ||
        this.groupObj.name.trim() == ""
      ) {
        this.$bvToast.toast(this.$t("Please enter the details properly"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        console.log(this.groupObj);
      }
    },
    async WhatsAppRecip() {
      this.requestWA = true;
      ////console.log(this.myObj.message);
      try {
        if (this.myObj.message.trim() == "") {
          this.$bvToast.toast(this.$t("Please enter message"), {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
        } else if (this.selectedRec.length == 0) {
          this.$bvToast.toast(this.$t("Please select the Recipients"), {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
        } else {
          // let data = this.customObj.numbers.join();
          // let cObj = {
          //   media: this.msgData.media,
          //   message: this.myObj.message,
          //   contacts: data,
          //   whatsapp: true,
          //   userID: this.$store.state.userData.userID,
          // };

          const stds = this.selectedRec.reduce((ids, el) => {
            el.role.toLowerCase() == "student" && ids.push(el.localID);
            return ids;
          }, []);
          const teas = this.selectedRec.reduce((ids, el) => {
            el.role.toLowerCase() == "teacher" && ids.push(el.localID);
            return ids;
          }, []);

          let cObj = {
            audio: "",
            media: this.msgData.media,
            message: this.myObj.message,
            sIDs: stds,
            tIDs: teas,
            campusID: this.$store.state.userData.cId,
            userID: this.$store.state.userData.userID,
          };
          // console.log(cObj);
          const waFallback = this.$t(
            "WhatsApp messages are being processed in the background."
          );
          var resp = await this.postObj({
            url:
              this.$store.state.domain +
              "Chat/SendMessageSelected?db=" +
              this.$store.state.userData.db,
            body: cObj,
            context: this,
            token: this.$store.state.userData.token,
            returnFullResponse: true,
            ignoreTimeout: true,
            backgroundProcessingMessage: waFallback,
          });
          this.handleSelectedChatSendResult(resp, waFallback, {
            closeSidebar: true,
          });
        }
      } catch (error) {
      } finally {
        this.requestWA = false;
      }
    },
    async WhatsApp() {
      this.requestWA = true;
      ////console.log(this.myObj.message);
      try {
        if (this.myObj.message.trim() == "") {
          this.$bvToast.toast(this.$t("Please enter message"), {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
        } else if (this.classID[0] == -2 && this.customContacts.trim() == "") {
          this.$bvToast.toast(this.$t("Please enter contact numbers"), {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
        } else {
          // For mobile view without template, set default media
          if (this.shouldHideTemplateInMobile && !this.myObj.media) {
            this.myObj.media = this.attachmentUrl || "";
          }
          let cObj = {
            media: this.shouldHideTemplateInMobile
              ? this.attachmentUrl || ""
              : this.msgData?.media || "",
            message: this.myObj.message,
            contacts: this.customContacts,
            whatsapp: true,
            userID: this.$store.state.userData.userID,
          };
          // console.log(cObj);
          const waFallback = this.$t(
            "WhatsApp messages are being processed in the background."
          );
          var resp = await this.postObj({
            url:
              this.$store.state.domain +
              "Chat/SendWhatsApp?db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.$store.state.userData.cId,
            body: cObj,
            context: this,
            token: this.$store.state.userData.token,
            returnFullResponse: true,
            ignoreTimeout: true,
            backgroundProcessingMessage: waFallback,
          });
          this.showChatSendFeedback(resp, waFallback);
        }
      } catch (error) {
      } finally {
        this.requestWA = false;
      }
    },
    async send() {
      //console.log(this.inputMessage);
      if (this.inputMessage.trim() !== "") {
        // donot show loader message input send
        // this.sendingMsg = true;
        let obj = {
          message: this.inputMessage,
          audio: "",
          media: this.media,
          localID: this.openedContact.localID,
          role: this.openedContact.role,
          campusID: this.$store.state.userData.cId,
          userID: this.$store.state.userData.userID,
          fromApp: true,
        };
        const newChatLog = {
          senderID: obj.userID,
          message: obj.message,
          media: obj.media,
          audio: obj.audio,
          time: new Date().toJSON(),
          date: new Date().toJSON(),
          role: obj.role,
          campusID: obj.campusID,
        };
        if (!Array.isArray(this.userChat)) {
          this.userChat = [];
        }
        this.userChat.push(newChatLog);
        this.inputMessage = "";
        this.media = null;
        this.$nextTick(() => {
          this.setChat();
        });
        //console.log(obj);
        var axios = require("axios");
        let config = {
          method: "post",
          url:
            this.$store.state.domain +
            "Chat/SendSingleMessage?db=" +
            this.$store.state.userData.db,
          data: obj,
          headers: {
            Authorization: "bearer " + this.$store.state.userData.token,
          },
        };
        axios(config)
          .then((res) => {
            this.getChat(this.openedContact, true);
          })
          .catch((err) => {
            //console.log(err);
          })
          .finally(() => {
            this.sendingMsg = false;
          });
      }
    },

    async loadHappinessDropdowns() {
      const [item1, item2] = await Promise.all([
        this.loadDropdownList("ageCategory"),
        this.loadDropdownList("empowerLevel"),
      ]);
      this.ageOptions = this.mapDropdownToOptions(item1) || [];
      this.ageOptions.unshift({ text: "All", value: "" });
      this.ageCategory = "";
      this.empowerLevelOptions = this.mapDropdownToOptions(item2) || [];
      this.empowerLevelOptions.unshift({ text: "All", value: "" });
      this.empowerLevel = "";
    },
    async loadDropdownList(category) {
      var obj = {
        url:
          this.$store.state.domain +
          "DropdownList/LoadData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&category=" +
          category,
        token: this.$store.state.userData.token,
      };
      const res = await this.get(obj);
      return Array.isArray(res) ? res : [];
    },
    mapDropdownToOptions(items) {
      if (!Array.isArray(items)) return [];
      return items
        .filter((el) => el.title != null && el.title !== "")
        .map((item) => ({
          text: item.title,
          value: item.title,
          id: item.id,
        }));
    },

    async LoadOthers() {
      this.otherLoading = true;
      var obj2 = {
        url:
          this.$store.state.domain +
          "myclasses/LoadClasses?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&dID=0",
        token: this.$store.state.userData.token,
      };
      this.classes = await this.get(obj2);
      //console.log("class", this.classes);
      this.classes.forEach((el) => this.classesOptions.push(el.cls));
      this.classesOptions.push(
        { name: "All Staff", id: -1 },
        { name: "Custom Contacts", id: -2 }
      ); //Custom Contacts
      // console.log(this.classesOptions);

      var obj = {
        url:
          this.$store.state.domain +
          "MessageTemplate?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.items = await this.get(obj);
      this.items = this.items.filter(
        (el) => el.sendOn == "" || el.sendOn == "Defaulters"
      );
      //console.log("temp", this.items);
      this.otherLoading = false;
    },
    async LoadData() {
      this.dataLoading = true;

      var obj2 = {
        url:
          this.$store.state.domain +
          "Chat/LoadData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      let res = await this.get(obj2);

      if (!Array.isArray(res)) {
        this.chatData = res;
        this.contactList = [...this.chatData.chat, ...this.chatData.contacts];
        this.contactList = this.contactList.filter(
          (el) => el.number != "" && el.number != null
        );
      }
      // console.log("data", this.chatData);
      // console.log(this.contactList);
      this.dataLoading = false;
      // this.LoadSettings();
    },
    async LoadRec() {
      this.recLoading = true;
      var obj2 = {
        url:
          this.$store.state.domain +
          "Chat/LoadRecipients?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      let res = await this.get(obj2);
      // console.log("rece", res);
      this.contactList = res.filter(
        (el) => el.number != "" && el.number != null
      );
      this.recLoading = false;
    },
    async refreshChat() {
      var obj = {
        url:
          this.$store.state.domain +
          "Chat/LoadChatPagination?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&page=1",
        token: this.$store.state.userData.token,
      };
      let res = await this.get(obj);
      // console.log(res);
      if (!Array.isArray(res)) {
        if (res.chat.length > 0) {
          this.currentChatPage = 2;
          this.chatTotal = res.total;
          this.chatPages = Math.ceil(this.chatTotal / this.perPage);
          this.chatData.chat = [...res.chat];

          this.currentContactPage = 1;
          this.contactTotal = 0;
          this.contactPages = 1;
          this.chatData.contacts = [];
          if (this.chatPages <= 1) this.LoadContact();
        }
      }
    },
    async LoadChatList(text) {
      this.moreChatLoading = true;

      var obj = {
        url:
          this.$store.state.domain +
          "Chat/LoadChatPagination?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&page=" +
          this.currentChatPage,
        token: this.$store.state.userData.token,
      };
      let res = await this.get(obj);
      // console.log(res);
      if (!Array.isArray(res)) {
        this.currentChatPage++;
        this.chatTotal = res.total;
        this.chatPages = Math.ceil(this.chatTotal / this.perPage);
        if (text == "load" && this.chatPages <= 1) this.LoadContact();
        this.chatData.chat = [...this.chatData.chat, ...res.chat];
        // let clist = res.chat.filter(
        //   (el) => el.number != "" && el.number != null
        // );
        // this.contactList = [...this.contactList, ...clist];

        // console.log(
        //   "count:",
        //   this.chatTotal,
        //   "pages",
        //   this.chatPages,
        //   "current",
        //   this.currentChatPage
        // );
      }
      this.moreChatLoading = false;
    },
    async LoadContact() {
      this.moreContactLoading = true;

      var obj = {
        url:
          this.$store.state.domain +
          "Chat/LoadContactPagination?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&page=" +
          this.currentContactPage,
        token: this.$store.state.userData.token,
      };
      let res = await this.get(obj);
      // console.log(res);
      if (!Array.isArray(res)) {
        this.currentContactPage++;
        this.contactTotal = res.total;
        this.contactPages = Math.ceil(this.contactTotal / this.perPage);
        this.chatData.contacts = [...this.chatData.contacts, ...res.chat];
        // let clist = res.chat.filter(
        //   (el) => el.number != "" && el.number != null
        // );
        // this.contactList = [...this.contactList, ...clist];

        // console.log(
        //   "count:",
        //   this.contactTotal,
        //   "pages",
        //   this.contactPages,
        //   "current",
        //   this.currentContactPage
        // );
      }
      this.moreContactLoading = false;
    },
    scrollHandle(el) {
      // console.log(el);
      // console.log(el.scrollHeight - el.scrollTop <= el.clientHeight + 200);
      if (el.scrollHeight - el.scrollTop <= el.clientHeight + 200) {
        if (!this.moreChatLoading && this.currentChatPage <= this.chatPages) {
          // console.log("load chat", this.currentChatPage);
          this.LoadChatList();
        }
        if (
          !this.moreContactLoading &&
          !this.moreChatLoading &&
          this.currentChatPage >= this.chatPages &&
          this.currentContactPage <= this.contactPages
        ) {
          // console.log("load contact", this.currentContactPage);
          this.LoadContact();
        }
      }
    },

    async LoadSettings() {
      var obj = {
        url:
          this.$store.state.domain +
          "NotificationSettings/LoadData?campusID=" +
          this.$store.state.userData.cId +
          "&db=" +
          this.$store.state.userData.db,
        token: this.$store.state.userData.token,
      };
      let result = await this.get(obj);

      if (result == null) {
        this.settings = {
          id: 0,
          campusID: this.$store.state.userData.cId,
          sendNotification: false,
          sendSMS: false,
          contact_father: false,
          contact_mother: false,
          contact_student: false,
        };
      } else {
        this.settings = result;
      }
      //console.log("set", this.settings);
    },
    async LoadGenSettings() {
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettings?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: ["family_wise_message", "branded-sms"],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });
      let obj = res.find((el) => el.key == "family_wise_message");
      if (obj) this.fObj = obj;
      else {
        this.fObj = {
          id: 0,
          campusID: this.$store.state.userData.cId,
          key: "family_wise_message",
          value: "family_wise_message",
          valueBool: false,
          valueNumber: null,
        };
      }
      let obj2 = res.find((el) => el.key == "branded-sms");
      this.brandedObj = obj2 ? obj2 : null;
    },
    openMore() {
      this.byRecipients = !this.byRecipients;
      let a = this.currentSt;
      setTimeout(() => {
        this.currentSt = a;
      }, 200);
      // this.visibility4 = true;
    },
    dropFilter(opt, label, search) {
      // console.log(opt, label, search);
      return (
        opt.name.toLowerCase().match(search.toLowerCase()) ||
        opt.details.toLowerCase().match(search.toLowerCase())
      );
    },
    setRecep() {
      this.customObj.numbers = this.selectedRec.reduce((nums, el) => {
        nums.push(el.number);
        return nums;
      }, []);
      // console.log(this.customObj.numbers);
    },
    async LoadMedia() {
      // Skip loading media if template is hidden in mobile view
      if (this.shouldHideTemplateInMobile) {
        return;
      }

      this.msgData = this.items.find((el) => el.id == this.msgID);
      // console.log(this.msgID, this.msgData);
      // var mObj = {
      //   url:
      //     this.$store.state.domain +
      //     "MessageTemplate/GetSelected/?id=" +
      //     this.msgID +
      //     "&db=" +
      //     this.$store.state.userData.db +
      //     "&cID=" +
      //     this.$store.state.userData.cId,
      //   token: this.$store.state.userData.token,
      // };
      // this.msgData = await this.get(mObj);
      if (this.msgData) {
        this.myObj.message = this.msgData.message;
        this.myObj.media = this.msgData.media;
      }
      // console.log("######### obj", this.myObj);
    },
    FillSections() {
      //return //console.log(this.classes);
      //console.log(this.classID);
      //   if (this.classID.includes(0) && this.classID.length == 2) {
      //     this.classID = this.classID.filter((e) => e !== 0);
      //   }

      // console.log(this.classID);
      if (
        this.classID[this.classID.length - 1] == -2 ||
        this.classID[this.classID.length - 1] == -1
      ) {
        this.classID = [this.classID[this.classID.length - 1]]; // will be -2 or -1

        this.admittedSections = [
          { section: "All " + this.allSectionLabel, id: 0 },
        ];
        if (this.classID[0] == -2) this.hideFields = true;
        else this.hideFields = false;
      } else {
        this.classID = this.classID.filter((e) => e !== -2 && e !== -1);
        this.hideFields = false;

        if (this.classID[0] == 0 && this.classID.length !== 1) {
          this.classID = this.classID.filter((e) => e !== 0);
          //console.log(this.classID);
          this.classes.forEach((elem) => {
            if (this.classID.includes(elem.cls.id)) {
              if (elem.sections.length != 0) {
                elem.sections.forEach((el) => this.admittedSections.push(el));
              } else {
                // console.log("null");
                this.admittedSections = [
                  { section: "All " + this.allSectionLabel, id: 0 },
                ];
              }
            }
          });
        } else if (
          this.classID[this.classID.length - 1] !== 0 &&
          this.classID.length == 1
        ) {
          this.classes.forEach((elem) => {
            if (this.classID.includes(elem.cls.id)) {
              if (elem.sections.length != 0) {
                elem.sections.forEach((el) => this.admittedSections.push(el));
              } else {
                // console.log("null");
                this.admittedSections = [
                  { section: "All " + this.allSectionLabel, id: 0 },
                ];
              }
            }
          });
        } else if (this.classID[this.classID.length - 1] == 0) {
          this.classID = [0];
          // console.log(this.classID);
          this.admittedSections = [
            { section: "All " + this.allSectionLabel, id: 0 },
          ];
          this.secID = [0];
        } else {
          this.admittedSections = [
            { section: "All " + this.allSectionLabel, id: 0 },
          ];
          this.secID = [0];
        }
      }
      // console.log(this.classID);
      this.CheckClass();
    },
    checkSections() {
      //console.log(this.secID);
      if (this.secID[0] == 0 && this.secID.length !== 1) {
        this.secID = this.secID.filter((e) => e !== 0);
        //console.log(this.secID);
      } else if (this.secID[this.secID.length - 1] == 0) {
        this.secID = [0];
        //console.log(this.secID);
      }
      this.CheckSec();
    },
    CheckClass() {
      // //console.log(this.my);
      var elem = this.$refs["class"];
      if (this.classID.length == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckSec() {
      if (this.classID[0] != 0 && this.classID[0] != -1) {
        var elem = this.$refs["section"];
        if (this.secID.length == 0) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else return true;
    },
    CheckTemp() {
      // Skip template validation if template is hidden in mobile view
      if (this.shouldHideTemplateInMobile) {
        return true;
      }

      var elem = this.$refs["temp"];
      if (this.msgID == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async save(type) {
      // this.myObj.media = null;
      // this.myObj.media = this.msgData.media;
      // console.log(this.myObj);
      this.CheckClass();
      this.CheckSec();
      this.CheckTemp();

      // Skip template validation if template is hidden in mobile view
      const shouldValidateTemplate = !this.shouldHideTemplateInMobile;

      if (
        this.CheckClass() == false ||
        this.CheckSec() == false ||
        (shouldValidateTemplate && this.CheckTemp() == false)
      ) {
        return this.$bvToast.toast(this.$t("Please fill the form correctly."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else if (this.myObj.message.trim() === "") {
        return this.$bvToast.toast(this.$t("Please enter message"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        // for staff
        if (this.classID[0] == -1) {
          this.myObj.clsIDs = [-1];
          this.myObj.secIDs = [];
        } else {
          if (this.classID[0] !== 0) {
            this.myObj.clsIDs = this.classID;
          } else {
            // this.myObj.clsIDs = [];
            this.myObj.clsIDs = this.classes.map((el) => el.cls.id);
          }
          if (this.secID[0] !== 0) {
            ////console.log(this.secID);
            this.myObj.secIDs = this.secID;
          } else {
            this.myObj.secIDs = [];
          }
        }
        //Add
        let endpoint = "Chat/SendMessage";
        let msg = "Message sent successfully.";

        if (type == "draft") {
          this.draftSending = true;
          msg = "Message saved as draft successfully.";
          endpoint = "Chat/SaveAsDraft";
        } else {
          this.request = true;
          if (this.currentSt == "registered")
            endpoint = "Chat/SendMessageRegistered";
        }

        const tempParam =
          this.currentSt == "present" && endpoint == "Chat/SendMessage"
            ? `&templateID=${this.msgID}`
            : "";

        // console.log("obj:", this.myObj);
        let dt = "";
        if (
          this.reportDomain == "myskoolstjacob" &&
          this.classID[0] != -2 &&
          this.classID[0] != -1 &&
          this.myObj.message.includes("{dues}")
        ) {
          dt = this.currentDate;
        }

        if (["myskoolhappinessfoundation"].includes(this.reportDomain)) {
          this.myObj.house = this.ageCategory;
          this.myObj.last_result = this.empowerLevel;
        }

        const sendFallback =
          type === "draft"
            ? msg
            : this.$t(
                "Messages are being processed in the background. Check Outbox for progress."
              );

        var status = await this.post({
          url:
            this.$store.state.domain +
            endpoint +
            "?db=" +
            this.$store.state.userData.db +
            "&date=" +
            dt +
            tempParam,
          body: this.myObj,
          context: this,
          token: this.$store.state.userData.token,
          allResponse: type !== "draft",
          ignoreTimeout: type !== "draft",
          backgroundProcessingMessage: sendFallback,
          message: type === "draft" ? msg : undefined,
        });
        this.request = false;
        this.draftSending = false;
        if (type === "draft") {
          if (status) this.visibility = false;
        } else if (this.showChatSendFeedback(status, sendFallback)) {
          this.visibility = false;
        }
      }
    },

    notificationRunStorageKey() {
      const db = this.$store.state.userData.db || "db";
      const userID = this.$store.state.userData.userID || "user";
      return `myskool-notification-running-${db}-${userID}`;
    },

    isNotificationRecentlySent() {
      try {
        const ts = Number(
          sessionStorage.getItem(this.notificationRunStorageKey()) || 0
        );
        if (!ts) return false;
        return Date.now() - ts < this.notificationCooldownMs;
      } catch (e) {
        return false;
      }
    },

    markNotificationStarted() {
      try {
        sessionStorage.setItem(
          this.notificationRunStorageKey(),
          String(Date.now())
        );
      } catch (e) {
        // sessionStorage may be unavailable; ignore
      }
    },

    /**
     * Frontend-only guard: if a notification was just sent / is still in flight,
     * remind the user before allowing another send.
     */
    async guardNotificationSend() {
      if (this.notificationSending || this.notificationRecipSending) {
        await this.$bvModal.msgBoxOk(
          this.$t(
            "Your notification is already running. Please wait for it to finish."
          ),
          {
            title: this.$t("Notification already running"),
            okTitle: this.$t("OK"),
            centered: true,
            okVariant: "primary",
          }
        );
        return false;
      }

      if (!this.isNotificationRecentlySent()) return true;

      const confirmed = await this.$bvModal.msgBoxConfirm(
        this.$t(
          "Your notification is already running. Do you want to send the notification again?"
        ),
        {
          title: this.$t("Notification already running"),
          okTitle: this.$t("Send again"),
          cancelTitle: this.$t("Cancel"),
          centered: true,
          okVariant: "primary",
          cancelVariant: "outline-secondary",
        }
      );

      return !!confirmed;
    },

    // Send Notification method
    async sendNotification() {
      if (!(await this.guardNotificationSend())) return;

      // Validate form first
      this.CheckClass();
      this.CheckSec();
      this.CheckTemp();

      // Skip template validation if template is hidden in mobile view
      const shouldValidateTemplate = !this.shouldHideTemplateInMobile;

      if (
        this.CheckClass() == false ||
        this.CheckSec() == false ||
        (shouldValidateTemplate && this.CheckTemp() == false)
      ) {
        return this.$bvToast.toast(this.$t("Please fill the form correctly."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else if (this.myObj.message.trim() === "") {
        return this.$bvToast.toast(this.$t("Please enter message"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }

      this.markNotificationStarted();
      this.notificationSending = true;

      console.log("Send Notification Debug:", {
        shouldHideTemplate: this.shouldHideTemplateInMobile,
        message: this.myObj.message,
        attachmentUrl: this.attachmentUrl,
        media: this.myObj.media,
      });

      try {
        // Prepare class and section IDs based on current selections
        let clsIDs = [];
        let secIDs = [];

        // Handle class IDs
        if (this.classID[0] == -1) {
          // All Staff
          clsIDs = [-1];
          secIDs = [];
        } else {
          if (this.classID[0] !== 0) {
            clsIDs = this.classID;
          } else {
            // All Classes
            clsIDs = this.classes.map((el) => el.cls.id);
          }

          if (this.secID[0] !== 0) {
            secIDs = this.secID;
          } else {
            secIDs = [];
          }
        }

        // Prepare notification payload
        const notificationPayload = {
          media: this.shouldHideTemplateInMobile
            ? this.attachmentUrl || ""
            : this.myObj.media || "",
          message: this.myObj.message,
          clsIDs: clsIDs,
          secIDs: secIDs,
          campusID: this.$store.state.userData.cId,
          userID: this.$store.state.userData.userID,
        };

        // Determine which API to call based on status
        let endpoint = "Chat/SendNotification";
        const successMessage = this.$t(
          "Notifications are being processed in the background."
        );

        if (this.currentSt == "registered") {
          endpoint = "Chat/SendNotification";
        }

        // Add template ID parameter if present
        const templateParam = this.msgID ? `&templateID=${this.msgID}` : "";

        const status = await this.post({
          url:
            this.$store.state.domain +
            endpoint +
            "?db=" +
            this.$store.state.userData.db +
            "&date=" +
            templateParam,
          body: notificationPayload,
          context: this,
          token: this.$store.state.userData.token,
          allResponse: true,
          ignoreTimeout: true,
          backgroundProcessingMessage: successMessage,
        });

        if (this.showChatSendFeedback(status, successMessage)) {
          this.visibility = false;
        } else if (status !== false && status != null) {
          this.visibility = false;
        } else {
          this.$bvToast.toast(
            this.$t("Failed to send notification. Please try again."),
            {
              title: this.$t("Error"),
              variant: "danger",
              solid: true,
              autoHideDelay: 5000,
            }
          );
        }
      } catch (error) {
        console.error("Error sending notification:", error);
        this.$bvToast.toast(
          this.$t("Failed to send notification. Please try again."),
          {
            title: this.$t("Error"),
            variant: "danger",
            solid: true,
            autoHideDelay: 5000,
          }
        );
      } finally {
        this.notificationSending = false;
      }
    },

    // Send Notification to Selected Recipients
    async sendNotificationRecip() {
      if (!(await this.guardNotificationSend())) return;

      if (this.myObj.message.trim() === "") {
        return this.$bvToast.toast(this.$t("Please enter message"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else if (this.selectedRec.length == 0) {
        return this.$bvToast.toast(this.$t("Please select the Recipients"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }

      this.markNotificationStarted();
      this.notificationRecipSending = true;

      try {
        // Separate students and teachers based on role
        const students = this.selectedRec.reduce((ids, el) => {
          if (el.role.toLowerCase() == "student") {
            ids.push(el.localID);
          }
          return ids;
        }, []);

        const teachers = this.selectedRec.reduce((ids, el) => {
          if (el.role.toLowerCase() == "teacher") {
            ids.push(el.localID);
          }
          return ids;
        }, []);

        // Prepare notification payload for selected recipients
        const notificationPayload = {
          audio: "",
          media: this.msgData?.media || "",
          message: this.myObj.message,
          sIDs: students, // Student IDs
          tIDs: teachers, // Teacher IDs
          campusID: this.$store.state.userData.cId,
          userID: this.$store.state.userData.userID,
        };

        // Call the notification API for selected recipients
        const notifFallback = this.$t(
          "Notifications to selected recipients are being processed in the background."
        );
        const response = await this.postObj({
          url:
            this.$store.state.domain +
            "Chat/SendNotificationSelected?db=" +
            this.$store.state.userData.db,
          body: notificationPayload,
          context: this,
          token: this.$store.state.userData.token,
          returnFullResponse: true,
          ignoreTimeout: true,
          backgroundProcessingMessage: notifFallback,
        });

        this.handleSelectedChatSendResult(response, notifFallback, {
          closeSidebar: true,
        });
      } catch (error) {
        console.error("Error sending notification to recipients:", error);
        this.$bvToast.toast(
          this.$t("Failed to send notification. Please try again."),
          {
            title: this.$t("Error"),
            variant: "danger",
            solid: true,
            autoHideDelay: 5000,
          }
        );
      } finally {
        this.notificationRecipSending = false;
      }
    },

    async LoadSMSOptions() {
      this.smsLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "SmsSettings/LoadData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&status=active",
        token: this.$store.state.userData.token,
      };
      this.smsOptions = await this.get(obj);
      this.smsLoading = false;
    },
    openSMSModal() {
      this.$bvModal.show("modal-sms");
      this.selectedSMS = null;
      this.LoadSMSOptions();
    },
    async sendSMS() {
      console.log(this.selectedSMS);
      // Validate form first
      this.CheckClass();
      this.CheckSec();
      this.CheckTemp();

      // Skip template validation if template is hidden in mobile view
      const shouldValidateTemplate = !this.shouldHideTemplateInMobile;

      if (
        this.CheckClass() == false ||
        this.CheckSec() == false ||
        (shouldValidateTemplate && this.CheckTemp() == false)
      ) {
        return this.$bvToast.toast(this.$t("Please fill the form correctly."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else if (this.myObj.message.trim() === "") {
        return this.$bvToast.toast(this.$t("Please enter message"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else if (!this.selectedSMS) {
        return this.$bvToast.toast("Please select a template", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }
      return;
      // will update later
      this.smsSending = true;

      try {
        // Prepare class and section IDs based on current selections
        let clsIDs = [];
        let secIDs = [];

        // Handle class IDs
        if (this.classID[0] == -1) {
          // All Staff
          clsIDs = [-1];
          secIDs = [];
        } else {
          if (this.classID[0] !== 0) {
            clsIDs = this.classID;
          } else {
            // All Classes
            clsIDs = this.classes.map((el) => el.cls.id);
          }

          if (this.secID[0] !== 0) {
            secIDs = this.secID;
          } else {
            secIDs = [];
          }
        }

        // Prepare notification payload
        const payload = {
          media: this.shouldHideTemplateInMobile
            ? this.attachmentUrl || ""
            : this.myObj.media || "",
          message: this.myObj.message,
          clsIDs: clsIDs,
          secIDs: secIDs,
          campusID: this.$store.state.userData.cId,
          userID: this.$store.state.userData.userID,
        };

        // Determine which API to call based on status
        let endpoint = "Chat/SendSMSMessage";
        // Chat/SendSMSSelected
        let successMessage = "Message sent successfully!";

        // Add template ID parameter if present
        const templateParam = this.msgID ? `&templateID=${this.msgID}` : "";

        // Call the notification API
        const status = await this.post({
          url:
            this.$store.state.domain +
            endpoint +
            "?db=" +
            this.$store.state.userData.db +
            "&smsID=" +
            this.selectedSMS +
            "&date=" +
            templateParam,
          body: payload,
          message: successMessage,
          context: this,
          token: this.$store.state.userData.token,
        });
      } catch (error) {
        console.error("Error sending message:", error);
        this.$bvToast.toast("Failed to send message. Please try again.", {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
          autoHideDelay: 5000,
        });
      } finally {
        this.smsSending = false;
      }
    },

    // Open Subject Mode
    openSubjectMode() {
      this.subjectMode = true;
      this.byRecipients = false;
      this.loadTeachers();
      this.loadSubjects();
    },

    // Exit Subject Mode
    exitSubjectMode() {
      this.subjectMode = false;
      this.selectedTeacher = null;
      this.selectedSubject = null;
      this.selectedRec = [];
    },

    // Clear Subject and move back to previous state
    clearSubject() {
      this.selectedSubject = null;
      this.selectedTeacher = null;
      this.subjects = []; // Clear subjects when teacher is cleared
      this.contactList = []; // Clear contact list when teacher is cleared
    },

    // Load Teachers
    async loadTeachers() {
      try {
        const obj = {
          url:
            this.$store.state.domain +
            "staff/LoadDataPagination?db=" +
            this.$store.state.userData.db +
            "&cId=" +
            this.$store.state.userData.cId +
            "&dptID=0&status=present&depname=&page=1&applicantStatus=&appointedFrom=&appointedTo=&sortBy=rfid&sortOrder=asc&pageSize=1000",
          token: this.$store.state.userData.token,
        };
        const response = await this.get(obj);
        // Transform the response to match the expected format
        this.teachers = response.map((teacher) => ({
          id: teacher.id,
          name: teacher.name,
          // Add other fields as needed
        }));
      } catch (error) {
        console.error("Error loading teachers:", error);
        this.teachers = [];
      }
    },

    // Load Subjects
    async loadSubjects() {
      try {
        const obj = {
          url:
            this.$store.state.domain +
            "Chat/LoadSubjects?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          token: this.$store.state.userData.token,
        };
        this.subjects = await this.get(obj);
      } catch (error) {
        console.error("Error loading subjects:", error);
        this.subjects = [];
      }
    },

    // Load Teacher Subjects
    async loadTeacherSubjects(teacherId) {
      this.subjectLoading = true;
      this.subjects = []; // Clear previous subjects
      this.selectedSubject = null; // Clear selected subject

      try {
        const obj = {
          url:
            this.$store.state.domain +
            "Students/GetTeacherSubjects?db=" +
            this.$store.state.userData.db +
            "&campusID=" +
            this.$store.state.userData.cId +
            "&tID=" +
            teacherId,
          token: this.$store.state.userData.token,
        };
        const response = await this.get(obj);
        console.log("Teacher Subjects API Response:", response);

        // Handle the API response format - check if it's wrapped in status/data or direct array
        let subjectsData = [];
        if (response && response.status === "success" && response.data) {
          // Wrapped format: {status: "success", data: [...]}
          subjectsData = response.data;
        } else if (Array.isArray(response)) {
          // Direct array format: [...]
          subjectsData = response;
        }

        if (subjectsData && subjectsData.length > 0) {
          this.subjects = subjectsData.map((subject) => ({
            id: subject.subID,
            name:
              subject.subject || subject.subName || `Subject ${subject.subID}`,
          }));
          console.log("Mapped subjects:", this.subjects);
          // Force reactivity update
          this.$forceUpdate();
        } else {
          console.log("No subjects found or invalid response");
          this.subjects = [];
        }
      } catch (error) {
        console.error("Error loading teacher subjects:", error);
        this.subjects = [];
      } finally {
        this.subjectLoading = false;
      }
    },

    // Load Students by Teacher and Subject
    async loadStudentsByTeacherAndSubject(teacherId, subjectId) {
      this.studentsLoading = true;
      this.contactList = []; // Clear previous students
      this.selectedRec = []; // Clear selected recipients

      try {
        const obj = {
          url:
            this.$store.state.domain +
            "Students/GetStudentsByTeacherAndSubject?db=" +
            this.$store.state.userData.db +
            "&campusID=" +
            this.$store.state.userData.cId +
            "&tID=" +
            teacherId +
            "&subID=" +
            subjectId,
          token: this.$store.state.userData.token,
        };
        const response = await this.get(obj);
        console.log("Students API Response:", response);

        // Handle the API response format - check if it's wrapped in status/data or direct array
        let studentsData = [];
        if (response && response.status === "success" && response.data) {
          // Wrapped format: {status: "success", data: [...]}
          studentsData = response.data;
        } else if (Array.isArray(response)) {
          // Direct array format: [...]
          studentsData = response;
        }

        if (studentsData && studentsData.length > 0) {
          this.contactList = studentsData.map((item) => ({
            localID: item.student.id,
            name: item.student.name,
            details: `${item.student.grNo} - ${item.student.cls_current.name}`,
            avatar: item.student.picture || "",
            number:
              item.student.contact_student || item.student.contact_father || "",
            role: "student",
          }));
          console.log("Mapped students:", this.contactList);
        } else {
          console.log("No students found or invalid response");
          this.contactList = [];
        }
      } catch (error) {
        console.error("Error loading students by teacher and subject:", error);
        this.contactList = [];
      } finally {
        this.studentsLoading = false;
      }
    },

    // Send Subject Notification
    async sendSubjectNotification() {
      if (!(await this.guardNotificationSend())) return;

      if (this.myObj.message.trim() === "") {
        return this.$bvToast.toast(this.$t("Please enter message"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else if (!this.selectedTeacher) {
        return this.$bvToast.toast("Please select a teacher", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else if (!this.selectedSubject) {
        return this.$bvToast.toast("Please select a subject", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }

      this.markNotificationStarted();
      this.notificationSending = true;

      try {
        // Use the students from the teacher-subject combination (auto-populated)
        const students = this.contactList.reduce((ids, el) => {
          if (el.role.toLowerCase() == "student") {
            ids.push(el.localID);
          }
          return ids;
        }, []);

        // Add the selected teacher to teachers array
        const teachers = [this.selectedTeacher];

        // Prepare notification payload for teacher-subject students
        const notificationPayload = {
          audio: "",
          media: this.msgData?.media || "",
          message: this.myObj.message,
          sIDs: students, // Student IDs from teacher-subject combination
          tIDs: teachers, // Selected teacher ID
          campusID: this.$store.state.userData.cId,
          userID: this.$store.state.userData.userID,
        };

        // Call the notification API for teacher-subject students
        const notifFallback = this.$t(
          "Notifications are being processed in the background."
        );
        const response = await this.postObj({
          url:
            this.$store.state.domain +
            "Chat/SendNotificationSelected?db=" +
            this.$store.state.userData.db,
          body: notificationPayload,
          context: this,
          token: this.$store.state.userData.token,
          returnFullResponse: true,
          ignoreTimeout: true,
          backgroundProcessingMessage: notifFallback,
        });

        if (this.showChatSendFeedback(response, notifFallback)) {
          this.visibility = false;
        }
      } catch (error) {
        console.error(
          "Error sending notification to teacher-subject students:",
          error
        );
        this.$bvToast.toast(
          this.$t("Failed to send notification. Please try again."),
          {
            title: this.$t("Error"),
            variant: "danger",
            solid: true,
            autoHideDelay: 5000,
          }
        );
      } finally {
        this.notificationSending = false;
      }
    },

    // Send WhatsApp for Subject
    async WhatsAppSubject() {
      this.requestWA = true;

      try {
        if (this.myObj.message.trim() == "") {
          this.$bvToast.toast(this.$t("Please enter message"), {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
        } else if (!this.selectedTeacher) {
          this.$bvToast.toast("Please select a teacher", {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
        } else if (!this.selectedSubject) {
          this.$bvToast.toast("Please select a subject", {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
        } else {
          // Use the students from the teacher-subject combination (auto-populated)
          const students = this.contactList.reduce((ids, el) => {
            if (el.role.toLowerCase() == "student") {
              ids.push(el.localID);
            }
            return ids;
          }, []);

          // Add the selected teacher to teachers array
          const teachers = [this.selectedTeacher];

          let cObj = {
            audio: "",
            media: this.msgData?.media || "",
            message: this.myObj.message,
            sIDs: students, // Student IDs from teacher-subject combination
            tIDs: teachers, // Selected teacher ID
            campusID: this.$store.state.userData.cId,
            userID: this.$store.state.userData.userID,
          };

          const waFallback = this.$t(
            "WhatsApp messages are being processed in the background."
          );
          var resp = await this.postObj({
            url:
              this.$store.state.domain +
              "Chat/SendMessageSelected?db=" +
              this.$store.state.userData.db,
            body: cObj,
            context: this,
            token: this.$store.state.userData.token,
            returnFullResponse: true,
            ignoreTimeout: true,
            backgroundProcessingMessage: waFallback,
          });
          this.handleSelectedChatSendResult(resp, waFallback, {
            closeSidebar: true,
          });
        }
      } catch (error) {
      } finally {
        this.requestWA = false;
      }
    },
  },
  setup() {
    const CHAT_APP_STORE_MODULE_NAME = "app-chat";

    // Register module
    if (!store.hasModule(CHAT_APP_STORE_MODULE_NAME))
      store.registerModule(CHAT_APP_STORE_MODULE_NAME, chatStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(CHAT_APP_STORE_MODULE_NAME))
        store.unregisterModule(CHAT_APP_STORE_MODULE_NAME);
    });

    const { resolveAvatarBadgeVariant } = useChat();

    // Scroll to Bottom ChatLog
    const refChatLogPS = ref(null);
    const scrollToBottomInChatLog = () => {
      const scrollEl = refChatLogPS.value.$el || refChatLogPS.value;
      scrollEl.scrollTop = scrollEl.scrollHeight;
    };

    // ------------------------------------------------
    // Chats & Contacts
    // ------------------------------------------------
    const chatsContacts = ref([]);
    const contacts = ref([]);

    const fetchChatAndContacts = () => {
      store.dispatch("app-chat/fetchChatsAndContacts").then((response) => {
        chatsContacts.value = response.data.chatsContacts;
        contacts.value = response.data.contacts;
        // eslint-disable-next-line no-use-before-define
        profileUserDataMinimal.value = response.data.profileUser;
      });
    };

    fetchChatAndContacts();

    // ------------------------------------------------
    // Single Chat
    // ------------------------------------------------
    const activeChat = ref({});
    const chatInputMessage = ref("");
    const userChat = ref([]);

    const openedOnce = ref(false);
    const opened = ref(false);
    const openChatOfContact = (contact) => {
      // Reset send message input value
      // chatInputMessage.value = "";
      // openedOnce.value = true;

      // store.dispatch("app-chat/getChat", { userId }).then((response) => {
      //   activeChat.value = response.data;

      //   // Set unseenMsgs to 0
      //   const contact = chatsContacts.value.find((c) => c.id === userId);
      //   if (contact) contact.chat.unseenMsgs = 0;

      //   // Scroll to bottom
      // });
      // const openedContact = ref({});

      // openedContact.value = contact;
      // var config = {
      //   url:
      //     store.state.domain +
      //     "Chat/LoadChatAdmin?db=" +
      //     store.state.userData.db +
      //     "&number=" +
      //     contact.number,
      //   headers: {
      //     Authorization: "bearer " + this.$store.state.userData.token,
      //   },
      // };
      // axios(config)
      //   .then((res) => {
      //     if (res.data.status == "success") {
      //       userChat.value = res.data.data;
      //       //console.log("chat", userChat);
      //       opened.value = true;
      //       nextTick(() => {
      //         scrollToBottomInChatLog();
      //       });
      //     }
      //   })
      //   .catch((err) => {
      //     //console.log(err);
      //   });

      // if SM device =>  Close Chat & Contacts left sidebar
      // eslint-disable-next-line no-use-before-define
      mqShallShowLeftSidebar.value = false;
    };
    const sendMessage = () => {
      if (!chatInputMessage.value) return;
      const payload = {
        contactId: activeChat.value.contact.id,
        // eslint-disable-next-line no-use-before-define
        senderId: profileUserDataMinimal.value.id,
        message: chatInputMessage.value,
      };
      store.dispatch("app-chat/sendMessage", payload).then((response) => {
        const { newMessageData, chat } = response.data;

        // ? If it's not undefined => New chat is created (Contact is not in list of chats)
        if (chat !== undefined) {
          activeChat.value = { chat, contact: activeChat.value.contact };
          chatsContacts.value.push({
            ...activeChat.value.contact,
            chat: {
              id: chat.id,
              lastMessage: newMessageData,
              unseenMsgs: 0,
            },
          });
        } else {
          // Add message to log
          activeChat.value.chat.chat.push(newMessageData);
        }

        // Reset send message input value
        chatInputMessage.value = "";

        // Set Last Message for active contact
        const contact = chatsContacts.value.find(
          (c) => c.id === activeChat.value.contact.id
        );
        contact.chat.lastMessage = newMessageData;

        // Scroll to bottom
        nextTick(() => {
          scrollToBottomInChatLog();
        });
      });
    };

    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    };

    // User Profile Sidebar
    // ? Will contain all details of profile user (e.g. settings, about etc.)
    const profileUserData = ref({});
    // ? Will contain id, name and avatar & status
    const profileUserDataMinimal = ref({});

    const shallShowUserProfileSidebar = ref(false);
    const showUserProfileSidebar = () => {
      store.dispatch("app-chat/getProfileUser").then((response) => {
        profileUserData.value = response.data;
        shallShowUserProfileSidebar.value = true;
      });
    };

    // Active Chat Contact Details
    const shallShowActiveChatContactSidebar = ref(false);

    // UI + SM Devices
    // Left Sidebar Responsiveness
    const { mqShallShowLeftSidebar } = useResponsiveAppLeftSidebarVisibility();
    const startConversation = () => {
      if (store.state.app.windowWidth < $themeBreakpoints.lg) {
        mqShallShowLeftSidebar.value = true;
      }
    };

    return {
      // Filters
      // formatDate,

      // useChat
      resolveAvatarBadgeVariant,

      // Chat & Contacts
      chatsContacts,
      contacts,

      // Single Chat
      refChatLogPS,
      activeChat,
      chatInputMessage,
      openedOnce,
      openChatOfContact,
      sendMessage,
      userChat,
      // openedContact,
      // opened,

      // Profile User Minimal Data
      profileUserDataMinimal,

      // User Profile Sidebar
      profileUserData,
      shallShowUserProfileSidebar,
      showUserProfileSidebar,

      // Active Chat Contact Details
      shallShowActiveChatContactSidebar,

      // UI
      perfectScrollbarSettings,

      // UI + SM Devices
      startConversation,
      mqShallShowLeftSidebar,
    };
  },
};
</script>

<style lang="css" scoped>
.myscroll {
  overflow-y: scroll;
  scroll-behavior: smooth;
}
.myscroll::-webkit-scrollbar {
  width: 10px;
}
.myscroll::-webkit-scrollbar-track {
  border: none;
  background-color: transparent;
  border-radius: 20px;
}
.myscroll::-webkit-scrollbar-thumb {
  border-radius: 20px;
  background-color: lightgray;
}
.file-type {
  background-color: #e62e2d;
  font-family: "Helvetica", sans-serif;
  color: white;
  border-radius: 10px;
  margin-right: 15px;
  height: 80px;
  width: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}

/* Custom mobile sidebar width for specific domains */
.sidebar-mobile-wide {
  width: 95% !important;
  max-width: 95% !important;
}

/* Ensure proper mobile responsiveness */
@media (max-width: 785px) {
  .sidebar-mobile-wide {
    width: 95% !important;
    max-width: 95% !important;
  }
}
</style>
<style>
.hidden_header {
  display: none;
}
</style>

<style lang="scss">
@import "~@core/scss/base/pages/app-chat.scss";
@import "~@core/scss/base/pages/app-chat-list.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
